<template>
    <div class="sum-nav hiddenScrollbar" >
        <div :style="{'width': dataList.length * 84 + 'px'}" class="nav-list">

            <div class="nav-item" :class="{active : currentIndex === index }"
                 v-for="(item , index) in dataList" :key="item.id"
                 @click="switchCategory(item, index)"  >
                <span >{{item.name}}</span>
            </div>

            <span v-show="status === 'ready' && dataList.length < 1">暂无任何分类</span>
        </div>

    </div>
</template>

<script>
import generalCmpPart from '@comp/part/generalCmpPart';

const config = {
    apiConfig : {
        list : {
            url : 'portal/base/overallCategory/allList',
            params : {
                typeEnum : 'ATLAS'
            },
            dataPath : 'data',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    }
};

export default {
    extends : generalCmpPart,
    components : {  },
    data () {
        return {
            // property from parent
            apiConfig : config.apiConfig,
            enableDataList : true,
            autoLoadDataList : true,
            scrollToLoadNextPage : false,

            // custom property
            currentIndex:-1,
        }
    },
    methods : {
        /**
         * @param   Object  dataItem
         * @param   Number  index
         */
        switchCategory(dataItem, index){
            this.currentIndex = index;
            let event = {
                type : 'change',
                data : dataItem
            };
            this.$emit('changeCategory', event);
        },
    }
}
</script>

<style lang="scss" scoped>
.sum-nav{
    overflow-x: auto;
    padding-bottom: 5px;
    padding-top: 2px;

    .nav-list{
        .nav-item{
            // width: 100px;
            height:100%;
            float: left;
            margin-right: 12px;

            font-size: 12px;

            width: 64px;
            height: 20px;
            line-height: 20px;
            padding: 0;
            background: #F2F3F8;
            border-radius: 12px;
            text-align: center;

            font-weight: 400;
            color: hsla(219, 9%, 39%, 1);

        }

        .active{
            padding: 1px 16px;
            background: #FDF4E7;

            border-radius: 15px;
            //margin-top: 5px;
            font-size: 12px;

            font-weight: 500;
            line-height: 20px;
            color: #FFA724;
        }

    }




}
</style>
